import { MessageId } from "@/v2/hooks/useTranslation";

import { FreeSpinsRetrievalTarget } from "../types/FreeSpinsRetrieval";

// `;` so Excel in European locales splits the columns.
export const CSV_SEPARATOR = ";";

// Tells Excel the file is UTF-8.
export const UTF8_BOM = String.fromCodePoint(0xfeff);

// Excel runs a cell starting with one of these as a formula.
export const CSV_FORMULA_TRIGGERS = ["=", "+", "-", "@", "\t", "\r"];

// Characters replaced with `-` in a file name.
export const FILE_NAME_UNSAFE_CHARACTERS = /[^a-z0-9]+/g;

// A dash left at either end of a file name; runs are already one dash.
export const FILE_NAME_EDGE_DASHES = /^-|-$/g;

// Retrieval unavailable for the integrator.
export const SYNC_REFUSED_STATUS = 400;

// Server errors keep their message hidden.
export const SERVER_ERROR_STATUS = 500;

// Results can show on another page, so the modal says what was retrieved.
export const TARGET_TYPE_LABEL: Record<FreeSpinsRetrievalTarget["type"], MessageId> = {
  integrator: "label.integrator",
  skin: "label.skin",
};
